import { init as initScreensaver } from './common/utils/screensaver'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VModal from 'vue-js-modal'
import './registerServiceWorker'

Vue.use(VModal)

// eslint-disable-next-line
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})

initScreensaver(60000)
